import { isEmpty } from '@dxb-web-ui-framework/common/utils/Helper';
import { UsernameRule, UsernameRuleResponseDTO } from '../entities';

const usernameRuleDTOToUsernameRuleAdapter = (data: UsernameRuleResponseDTO): UsernameRule[] => {
  if (!data.body) {
    throw new Error('Error');
  }

  const { rules } = data.body;

  if (isEmpty(rules)) {
    return [];
  }
  return rules.map(rule => new UsernameRule(rule.ruleType, rule.value));
};

export { usernameRuleDTOToUsernameRuleAdapter };
